import { useCallback } from 'react';
import useRouterState, { type Options } from '@discover-use-router-state';
import { useStoreState } from '@discover-data/stores/restaurant/hooks';

// using `useRouterState` directly instead of the individual use filter hooks because we need to set all at the same time and the `useQueryState` hook can't handle simultaneous set calls
export default function useResetFilters(routerKeys: string[]) {
  const storeMode = useStoreState((state) => state.mode);
  const [, setRouterValues] = useRouterState(routerKeys);

  const resetFilters = useCallback(
    async (options?: Options) => {
      const emptyFilterValues = routerKeys.reduce((emptyValues: { [key: string]: [] }, key) => {
        emptyValues[key] = [];

        return emptyValues;
      }, {});

      await setRouterValues(emptyFilterValues, options);
    },
    [routerKeys, setRouterValues, storeMode]
  );

  return resetFilters;
}
